import type { ScoreItem } from '@talentmesh/utils';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import ScoreOverview from './Components/ScoreOverview';
import EmotionalIntelligenceScoreDetails from './EmotionalIntelligence/EmotionalIntelligenceScoreDetails';
import UIStrings from '@/Utils/UIStrings';

function EmotionalIntelligenceTab() {
    const { results } = useCandidatesResultsContext();
    const { emotionalIntelligenceScore, candidateFirstName } = results;

    if (emotionalIntelligenceScore) {
        const { percentileScore, percentileLevel } = emotionalIntelligenceScore;

        const overall: ScoreItem = {
            level: percentileLevel,
            name: UIStrings.OverallScore,
            value: percentileScore,
        };

        const scores: ScoreItem[] = emotionalIntelligenceScore.characteristics.map((characteristic) => {
            return {
                level: characteristic.percentileLevel,
                name: characteristic.characteristicName,
                value: characteristic.percentileScore,
            };
        });

        return (
            <div className="mb-5 flex flex-col gap-5">
                <ScoreOverview
                    scoreOverviewTitle={UIStrings.EmotionalIntelligenceScoreOverview}
                    scoreOverviewDescription={UIStrings.TheOverallScoreIsCalculatedBasedOnEI}
                    candidateFirstName={candidateFirstName}
                    scores={scores}
                    overall={overall}
                />
                <EmotionalIntelligenceScoreDetails />
            </div>
        );
    }
    return null;
}

export default EmotionalIntelligenceTab;
